// Bundle dependencies

import Plugin from './Plugin';


export default {

  version: () => {
    return NSContext.plugins.postnav.version;
  }

};


// Initialize on document ready

// document.addEventListener("DOMContentLoaded", function () {
//   Plugin.init();
// });